module.exports = __webpack_public_path__ + "static/img/8.cf3e76f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxopen/8.png
// module id = wK8k
// module chunks = 1